import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
// import Chip from '@mui/material/Chip';
import { ExpandableFeatureLayout } from '@lendica/components';
import { useCompanyNavigate } from '@lendica/hooks';
import { env } from '../api/axiosInstance';

export const AddCompany = () => {
    const navigate = useCompanyNavigate();
    return (
        <ExpandableFeatureLayout maxWidth={600}>
            <Box
                sx={{
                    px: 4,
                    height: '100%',
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 3,
                    textAlign: 'center',
                }}
            >
                {/* <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 1,
                    }}
                >
                    <Chip label="Coming Soon" size="medium" variant="outlined" color="info" />
                    <Typography variant="h3">Add Company</Typography>
                </Box> */}
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 1,
                        border: '1px solid #E0E0E0',
                        borderRadius: '10px',
                        padding: '16px',
                        maxWidth: 480,
                        width: '100%',
                    }}
                >
                    <Typography variant="h6" sx={{ textAlign: 'left', width: '100%', mb: 1 }}>
                        How to add a new company
                    </Typography>
                    <Alert
                        severity="success"
                        sx={{ width: '100%', whiteSpace: 'pre-line', textAlign: 'left' }}
                    >
                        {`If your company already uses Daylit, ask a teammate to send you an invite.`}
                    </Alert>
                    <Alert
                        severity="info"
                        sx={{ width: '100%', whiteSpace: 'pre-line', textAlign: 'left' }}
                    >
                        {`To onboard a new company to Daylit, `}
                        <a
                            href={
                                env === 'prod'
                                    ? 'https://apply.golendica.com?utm_source=daylit&utm_medium=portal&utm_campaign=add_company'
                                    : 'https://apply.app-idev.golendica.com?utm_source=daylit&utm_medium=portal&utm_campaign=add_company'
                            }
                            target="_blank"
                            style={{ textDecoration: 'underline' }}
                        >
                            click here to start a new application
                        </a>
                        {` and contact us if you have any issues.`}
                    </Alert>

                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'flex-end',
                            gap: 1,
                            mt: 2,
                        }}
                    >
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                window.HubSpotConversations?.widget.open();
                            }}
                        >
                            Contact support
                        </Button>
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={() => {
                                navigate('/wallet');
                            }}
                        >
                            Back to wallet
                        </Button>
                    </Box>
                </Box>
            </Box>
        </ExpandableFeatureLayout>
    );
};
